module.exports = __webpack_public_path__ + "img/Journalism01.cba2bcd4.png";